import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { EditOrdersComponent } from "./edit-orders/edit-orders.component";

@Injectable()
export class CanDeactivateEditOrders  {
  constructor() { }

  canDeactivate(
    component: EditOrdersComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !!component && component.trySaveOnClose();
  }
}
